// Convert FastAPI/axios error into a user-readable string
// FastAPI returns either:
//   - {detail: "string"} for HTTPException
//   - {detail: [{type, loc, msg, input, ctx}]} for 422 validation
//   - other axios errors with err.message
export function errorMessage(err, fallback = "Something went wrong") {
  try {
    const d = err?.response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
      return d.map((e) => {
        const where = Array.isArray(e?.loc) ? e.loc.filter((x) => x !== "body").join(".") : "";
        return where ? `${where}: ${e.msg}` : e.msg || JSON.stringify(e);
      }).join(" \u2022 ");
    }
    if (d && typeof d === "object") return JSON.stringify(d);
    if (err?.message) return err.message;
  } catch {}
  return fallback;
}
